module.exports = __webpack_public_path__ + "img/icon-diamond-on.159c41e.webp";